import { BatchLoadExperimentsData } from 'business/models/Models';
import {
  FmlxTableBody,
  FmlxTableContainer,
  FmlxTableHead,
  FmlxTableHeadCell,
  FmlxTableRow,
} from 'fmlx-common-ui';
import React, { useEffect, useMemo } from 'react';
import BatchloadTableRow from './BatchloadTableRow';

export interface ColumnDef {
  id: string;
  key: string;
  title: string;
  showStatusBorder: boolean;
  textAlign?: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  textWrap?: 'wrap' | 'noWrap';
}

export type BatchloadTableProps = {
  id: string;
  columns: ColumnDef[];
  tableData: BatchLoadExperimentsData[] | null | undefined;
  onReady?: () => void;
  customHeight?: string | null | undefined;
  customWidth?: string | null | undefined;
};

export const BatchloadTable = ({
  id,
  columns,
  tableData,
  onReady,
  customHeight,
  customWidth,
}: BatchloadTableProps) => {
  // Notify when the table is mounted
  useEffect(() => {
    onReady?.();
  }, []);

  const tableHeaders = useMemo(() => {
    return (
      <FmlxTableHead
        id={`${id}-fmlxtablehead`}
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <FmlxTableRow id={`${id}-fmlxtablerow-header`} onClick={null}>
          {columns.map((column: any, idx: number) => {
            return (
              <FmlxTableHeadCell
                id={`${id}-fmlxtableheadcell-column-${column.id}`}
                key={`fmlx-table-head-cell-${idx}`}
                label={column.title}
                sortDisabled
                onClickSort={null}
                size={'small'}
                className="sticky top-0 z-10 text-nowrap text-xs"
              />
            );
          })}
        </FmlxTableRow>
      </FmlxTableHead>
    );
  }, [id, columns]);

  const tableBody = useMemo(() => {
    return (
      <FmlxTableBody
        id={`${id}-fmlxtablebody`}
        sx={{
          minHeight: 0,
          overflow: 'auto',
        }}
      >
        {tableData?.map((data: BatchLoadExperimentsData, rowIndex: number) => {
          return (
            <BatchloadTableRow
              key={`batchload-row-${rowIndex}`}
              rowIndex={rowIndex}
              rowData={data}
              rowColumns={columns}
              id={id}
            />
          );
        })}
      </FmlxTableBody>
    );
  }, [id, tableData]);

  return (
    <FmlxTableContainer
      id={`${id}-fmlxtablecontainer`}
      stickyHeader
      size={'small'}
      classNames={{
        base: '',
        content: '',
      }}
      sxs={{
        base: { height: customHeight ?? '46vh', width: customWidth ?? '100%' },
      }}
    >
      {tableHeaders}
      {tableBody}
    </FmlxTableContainer>
  );
};
